module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_106476-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_106476-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847675644_tableofcontents"
    }
  }, [_vm._v("The Adoration of the Mini")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_106476-00002"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("T WAS")]), _vm._v(" "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("AN")]), _vm._v(" old people’s hospital and yet he wasn’t old. As she stood at the door about to press the bell she looked around her and saw beside a shrouded wheelchair some tulips swaying in the white March wind. Turning her head into the cold bright sun, she saw farther down the road a fat man in blue washing a bright red car. She felt joyous and sad by turns.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00003"
    }
  }, [_vm._v("She pressed the bell, and a nurse in white and blue came to the door. Visiting hours were two to three, but she thought she could call at any time now. The nurse was stony-faced and middle-aged and glancing at her quickly seemed to disapprove of the roundness of her body: it was not the place for it. She pushed back her blonde hair which had been slightly disarranged by the wind. She asked for Mr Mason, and the nurse showed her the door of the ward. Here and there she could see other nurses, but none of them was young; it would have been better if at least one or two had the expectancy and hope of youth. It would make the place brighter, younger, with a possible future.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00004"
    }
  }, [_vm._v("She walked into the ward. The walls were flaked with old paint, and old men, propped on pillows, stared ahead of them without recognition or care. One old man with a beard, his eyes ringed with black as if from long sleeplessness, looked through her as though she had been a window pane beyond which there was no country that he could love or desire. By one or two beds—the bedside tables bearing their usual offerings of grapes and oranges, and bottles of yellow energy-giving liquids wrapped in cellophane—there were women talking in whispers.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00005"
    }
  }, [_vm._v("She walked through the main ward, not seeing him, and then through into a smaller one. And there he was, on his "), _c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("own, sitting up against the pillows as if waiting. But he could not be expecting her. He might be expecting her mother or her brother or her other sister, but not her.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_106476-00006"
    }
  }, [_vm._v("The smell of imminent death was palpable and distinct. It was in the room, it was all round him, it impregnated the sheets, it was in his face, in his eyes. She had seen him ill before, but not like this. His colour was neither yellow nor red, it was a sort of grey, like old paper. The neck was long and stringy, and the knotted wrists rested meagrely on the sheet in front of him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00007"
    }
  }, [_vm._v("She stood at the foot of the bed and looked at him. He looked back at her without energy. She said,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00008"
    }
  }, [_vm._v("‘I came to see you, father.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00009"
    }
  }, [_vm._v("He made no answer. It was as if he hadn’t heard her or as if (if he had heard her) she wasn’t worth answering. She noticed the carafe of water at the table at the foot of the bed and said,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00010"
    }
  }, [_vm._v("‘Do you want a drink?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00011"
    }
  }, [_vm._v("He remained silent. She began again:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00012"
    }
  }, [_vm._v("‘I came up by train today. It took me eight hours.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00013"
    }
  }, [_vm._v("She shook her yellow hair as if to clear her head and said,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00014"
    }
  }, [_vm._v("‘May I sit down?’ He still didn’t speak and she sat down on the chair. He spoke at last:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00015"
    }
  }, [_vm._v("‘How do you think I look?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00016"
    }
  }, [_vm._v("She replied with conscious brightness,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00017"
    }
  }, [_vm._v("‘I had thought you would be worse.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00018"
    }
  }, [_vm._v("‘I think I’m dying,’ he said tonelessly and almost with cunning, ‘I’ve had strange visions.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00019"
    }
  }, [_vm._v("He shut his eyes for a moment as if to rest them.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00020"
    }
  }, [_vm._v("‘What do you want?’ he asked without opening his eyes.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00021"
    }
  }, [_vm._v("‘I wanted to see you.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00022"
    }
  }, [_vm._v("‘What about?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00023"
    }
  }, [_vm._v("‘I …’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00024"
    }
  }, [_vm._v("‘You left a good job and went off to London and you’re pregnant, isn’t that right,’ he said slowly, as if he were carving something with a chisel and hammer. ‘You had a good brain and you threw it all away. You could have gone on to university.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00025"
    }
  }, [_vm._v("‘We’re married now,’ she said.")])]), _c('p', {
    attrs: {
      "id": "rw-p_106476-00027"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("‘I know that. You married a Catholic. But then Catholics breed a lot, don’t they?’ He opened his eyes, looking at her in disgust, his nose wrinkling as if he could smell incense. She flared up, forgetting that he was dying.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_106476-00028"
    }
  }, [_vm._v("‘You know why I left, father. I didn’t want to go to university. I’m an ordinary person.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00029"
    }
  }, [_vm._v("‘You had an "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("I.Q")]), _vm._v(". of 135. I shouldn’t be telling you this but I saw it on your school records.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00030"
    }
  }, [_vm._v("‘I didn’t want to go to university. I didn’t want to do Science.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00031"
    }
  }, [_vm._v("‘I didn’t care. It didn’t need to be Science. It could have been any subject. You threw yourself away. You went to work in a wee office. And then you got pregnant. And now you say you are married. To a Catholic. And you’ll have to be a Catholic too. I know them. And your …’ He couldn’t bring himself to say that her child would be a Catholic.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00032"
    }
  }, [_vm._v("She couldn’t stop herself. ‘I thought a scientist wouldn’t care for these things. I thought a scientist would be unprejudiced.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00033"
    }
  }, [_vm._v("He smiled grimly. ‘That’s the kind of remark I would have expected from you. It shows that you have a high "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("I.Q")]), _vm._v(". You should have used it. You threw it away. You ignored your responsibilities. You went off to London, to see the bright lights.’ She sensed envy in his voice.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00034"
    }
  }, [_vm._v("After a while she said,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00035"
    }
  }, [_vm._v("‘I couldn’t stand school. I don’t know how I can explain it to you. The books didn’t mean anything after a while. It was torture for me to read them. Can you understand that?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00036"
    }
  }, [_vm._v("‘No.’ His mouth shut like a rat-trap.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00037"
    }
  }, [_vm._v("‘I tried,’ she continued. ‘I did try. But they didn’t mean anything. I would look at a French book and a Latin book and it didn’t connect with anything. Call it sickness if you like, but it’s true. It was as if I was always tired. I used to think it was only people in non-academic classes who felt like that. I was all right in the first three years. Everything seemed to be interesting. And then this sickness hit me. All the books I read ceased to be interesting. It was as if a haze came down, as if the words lost any meaning, any reality. I liked music but there was nothing for me in words. I’m trying to explain. It was a sickness. Don’t you understand?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_106476-00039"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘No, I don’t understand. When I was in the upper school I wasn’t like that. I read everything I could lay my hands on. Books were treasures. When I was in university it was the same. I read because I loved to read. I wanted to have as much knowledge as possible. Even now …’ He paused.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_106476-00040"
    }
  }, [_vm._v("She probed: ‘Even now?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00041"
    }
  }, [_vm._v("But he had stopped speaking, like a watch run down. She continued,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00042"
    }
  }, [_vm._v("‘Yes, I admired that in you, though you were narrow-minded. I admired your love of books and knowledge and experiments. I admired you for thinking out new ways of presenting your subject. I admired your enthusiasm, though you neglected your family. And then too you went to church. What did you find in church?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00043"
    }
  }, [_vm._v("‘In church? I found silence there.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00044"
    }
  }, [_vm._v("‘It was different with us,’ she continued. ‘It wasn’t that I didn’t try. I did try. I would lock myself in my room and I would study my Virgil. I would stare at it. I would look up meanings. And then at the end of an hour I hadn’t moved from the one page. But I tried. It wasn’t my fault. Can’t you believe me?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00045"
    }
  }, [_vm._v("‘I don’t understand.’ Then he added mercilessly, ‘It was idleness.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00046"
    }
  }, [_vm._v("‘And there you would be in the other room, in your study, preparing your lesson for the following day, smoking your pipe, thinking up new ideas like the time you made soap. You were the mainstay of the school, they said. So much energy. Full of power, boyish, always moving, always thinking. Happy.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00047"
    }
  }, [_vm._v("A smile crossed his face as if he were looking into another world which he had once loved and in which he had meaning and purpose.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00048"
    }
  }, [_vm._v("‘Yes, I gave them a lot,’ he said. ‘A lot. I tried my best with you as well. I spent time on you. I wanted you to do well. But I couldn’t make a favourite of you. And then you said you were leaving.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_106476-00049"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘It happened one night. I had been doing some exercises in English. I think it was an interpretation passage. I was sitting at the table. There was a vase with flowers in front ")]), _c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("of me. The electric light was on, and then I switched on the radio and I heard this voice singing “Frankie and Johnny”. It was Lena Horne. I listened to it. At first I wasn’t listening to it at all. I was trying to do my exercise. Then, after a while, the music seemed to become more important than what I was doing. It defeated what I was doing. It was about real things and the interpretation wasn’t about anything. Or rather, it was about the lack of trade unionism in Japan. I’m not joking: that’s what it was. How the bosses wouldn’t allow the workers any unions and how they kept their money for them. It had no meaning at all. It was like…It was like some obstacle that you pushed against. Like a ghost in a room. And I laid down my pen and I said to myself, What will happen if I stop doing this? And then I did stop. And suddenly I felt so free. It was as if I had lightened myself of some load. I felt free. I listened to the song and I didn’t feel any guilt at all.’")])]), _c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_106476-00050"
    }
  }, [_vm._v("He looked at her almost with hatred.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00051"
    }
  }, [_vm._v("‘If you didn’t feel any guilt why are you here then? Why didn’t you stay with your Catholic? By the way, what does he do?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00052"
    }
  }, [_vm._v("‘He has an antique shop. Actually, he’s quite scholarly. He’s more scholarly than you. He knows a lot about the Etruscans. He’s very enthusiastic. Just like you. He’s got a degree.’ She laughed, bubbling.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00053"
    }
  }, [_vm._v("‘In that case,’ he said, ‘why didn’t you stay with him?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00054"
    }
  }, [_vm._v("‘I came to ask you,’ she said ‘what it all means.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00055"
    }
  }, [_vm._v("He said, ‘I remember one morning at a lecture we were told about Newton. It was a long time ago and it was a large lecture room, row upon row of pupils, students stretching to the very back and rising in tiers. There was sunlight and the smell of varnish. And this bald man told us about Newton. About the stars and how everything was fixed and unalterable and the apple falling to the ground in a garden during the Plague. Harmony. He talked about harmony. I thought the sky was full of apples. And that the whole world was a tree.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00056"
    }
  }, [_vm._v("There was a long silence. In it she felt the child turning in its own orbit.")])]), _c('p', {
    attrs: {
      "id": "rw-p_106476-00057"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘What use are the books to you now?’ she said. The words ")]), _c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("sounded incredibly naive almost impudent and inhuman but she didn’t mean them like that. And yet…")])]), _c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_106476-00058"
    }
  }, [_vm._v("‘You mean,’ he said, ‘that my life was useless. That I spent my days and nights on phantoms. Is that what you want? Did you come to gloat?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00059"
    }
  }, [_vm._v("‘No, I want to know, that’s all. I want to know if it was something wrong with me. Perhaps it was something wrong with me all the time.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00060"
    }
  }, [_vm._v("She imagined him walking in the middle of the night, listening to the silence of the wards, watching the moonlight on the floor. She imagined him looking into the eyes of nurses for reassurance, without speech. She imagined him imagining things, the whispers, the rumours, the laughter. Sometimes a man would die and his bed would be empty. But there would always be another patient. She imagined him thinking: At what hour or minute will I die? Will I die in pain? Will I choke to death?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00061"
    }
  }, [_vm._v("She thought of London and of this small place. She thought of the anonymity of London, the death of the rainy days. The lostness. The strangeness. Had she chosen well? She thought of Sean, with his small tufted beard, vain, weak, lecherous. He was her only link with that brutal city. All else flowed, she could only follow him, the indeterminate atom.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00062"
    }
  }, [_vm._v("‘You don’t know what duty is,’ he said at last. ‘You live on romance and pap. I’ve seen you reading "), _c('i', [_vm._v("Woman’s Own")]), _vm._v(". You think that the world is romantic and beautiful.’ (Did she think that? Was that why she had run away? Did she think that now? What had she not seen? Into the heart of the uttermost darkness in that room where at night the lights circled the ceiling, and nothing belonged to her, not even the flat, not the Etruscan soldiers with their flat, hollow sockets.)")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00063"
    }
  }, [_vm._v("‘You don’t know about trust and loyalty. You knuckle under whenever any difficulty crops up. Your generation is pap and wind. You owe allegiance to nothing. I have owed allegiance to this place. They may forget me, but I served. What else is there to do?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00064"
    }
  }, [_vm._v("She said in a low voice, ‘To live.’ But he hadn’t heard her.")])]), _c('p', {
    attrs: {
      "id": "rw-p_106476-00066"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("‘To serve,’ he said. ‘To love one’s work. Oh, I was no Einstein but I loved my work and I think I did good. You, what do you do?’")])]), _c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_106476-00067"
    }
  }, [_vm._v("Nothing, she thought, except to live where the lightning is, at the centre where the lightning is. At the disconnected places. At the place where our truth is to be found on the rainwashed blue bridges. At the place without hypocrisy. In the traffic. Where she would have to fight for everything including her husband, not knowing that at least this she could keep, as her mother had known. In the jungle.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00068"
    }
  }, [_vm._v("She stood up and said, ‘Goodbye, father.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00069"
    }
  }, [_vm._v("Defiantly he said, ‘You refused your responsibility.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00070"
    }
  }, [_vm._v("It was like standing on a platform waving to a stranger on a train. For a moment she couldn’t make up her mind whether he was leaving her or she leaving him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00071"
    }
  }, [_vm._v("He relapsed into petulance. ‘I shouted for the nurse last night but she was too busy. She heard me right enough but she didn’t come.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00072"
    }
  }, [_vm._v("She thought to herself: There is a time when one has to give up, when nothing more can be done. When the connection has to be cut. It is necessary, for not all things are retrievable.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00073"
    }
  }, [_vm._v("As she stood up she nearly fell, almost upsetting the carafe of water, herself full of water.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00074"
    }
  }, [_vm._v("He had closed his eyes again when she turned away and walked through the ward head down, as if fighting a strong wind. She paused outside the door in the blinding March light where the tulips were.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00075"
    }
  }, [_vm._v("The man she had seen before had finished polishing his car and was looking at it with adoration. She thought: The Adoration of the Mini, and smiled.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_106476-00076"
    }
  }, [_vm._v("The child stirred. The world spun and took its place, the place that it must have as long as she was what she was. She had decided on it. And what she was included her father. And she thought again of her child, loving and pitying it.")])])]), _c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a8f4ec2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847675644_chapter_02.vue
// module id = 72
// module chunks = 0